export default (input) => {
  return {
    ...input
  };
};
